import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../../../store';
import { 
  fetchDSDZoneVolumeDistributionByDay, 
  fetchNONDSDZoneVolumeDistributionByDay,
  fetchDSDDailyPercentage,
  // fetchNONDSDDailyPercentage, // Commented out - UI table is disabled
  fetchShiftTimes,
  fetchHistoricalHours
} from '../../../../../store/thunks/dloThunks';
import { 
  selectLocationHistoricalHoursSaved,
  selectLocationHistoricalHoursSaving 
} from '../../../../../store/slices/dloSlice';

export const useDLOLocationData = () => {
  const dispatch = useAppDispatch();
  
  // Get all location setting data from Redux
  const dloLocationSetting = useSelector((state: RootState) => state.dlo.locationSetting);
  const historicalHoursSaved = useSelector(selectLocationHistoricalHoursSaved);
  const historicalHoursSaving = useSelector(selectLocationHistoricalHoursSaving);

  // Fetch all location setting data on component mount
  useEffect(() => {
    dispatch(fetchDSDZoneVolumeDistributionByDay()).then(() => {
      dispatch(fetchDSDDailyPercentage());
    });
    dispatch(fetchNONDSDZoneVolumeDistributionByDay());
    // dispatch(fetchNONDSDDailyPercentage()); // Commented out - UI table is disabled
    dispatch(fetchShiftTimes());
    dispatch(fetchHistoricalHours());
  }, [dispatch]);

  return {
    dloLocationSetting,
    historicalHoursSaved,
    historicalHoursSaving
  };
};
